/*
 * @Description: 日桌面育苗图表接口
 * @Author: zcy
 * @Date: 2022-02-21 11:31:32
 * @LastEditors: zcy
 * @LastEditTime: 2022-03-29 11:16:31
 */
import http from "../../../axios/index";

const service = {
  // 饲料现存量图表接口
  getMdtFodderDataGroupByChart(params) {
    let {
      orgId,
      day,
    } = params;
    return http.post('/mdtFodderDataGroup/getMdtFodderDataGroupByChart', {
      orgId,
      day
    });
  },

  // 动保现存量图表接口
  DynamicGetChatrs(params) {
    let {
      orgId,
      day,
    } = params;
    return http.post('/mdtDrugDataGroup/getMdtDrugDataGroupByChart', {
      orgId,
      day
    });
  },

  // 饲料日投喂图表接口
  getPrivateChatCharts(params) {
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/trFeedingDetailDay/getFeedingDailyGroupByChart', {
      orgId,
      breedTypeClass,
      day
    });
  },

  // 动保日投用数据接口
  getDynamicCharts(params) {
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/trDrugBoxDaily/getFishUseMedicineGroupByChart', {
      orgId,
      breedTypeClass,
      day
    });
  },

  // 一批次各品种收获情况
  getBreedPageList(params) {
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/searchMdtHarvestAnalysisOrgByHarvestList', {
      orgId,
      breedTypeClass,
      day
    });
  },
  // 一批次各品种投卵情况
  getThrowEggPageList(params) {
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/searchMdtHarvestAnalysisOrgByPutNumList', {
      orgId,
      breedTypeClass,
      day
    });
  },
  // 一批次饲料使用情况
  getFeedPageList(params) {
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/searchMdtHarvestAnalysisOrgByUseFodderList', {
      orgId,
      breedTypeClass,
      day
    });
  },

  // 一批次各品种育苗天数与投入成本
  getMdtHarvestAnalysisOrgByChart(params) {
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/getMdtHarvestAnalysisOrgByChart', {
      orgId,
      breedTypeClass,
      day
    });
  },
  // 一批次销售产值、一批次收获总产量
  searchMdtHarvestAnalysisOrgForTargetValue(params){
    let {
      orgId,
      breedTypeClass,
      day,
    } = params;
    return http.post('/mdtHarvestAnalysisOrg/searchMdtHarvestAnalysisOrgForTargetValue', {
      orgId,
      breedTypeClass,
      day
    });
  }
}

export default service